import React from 'react'

export default function SecondaryButton({children}) {
  return (
    <div className='secondary-btn'>{children}</div>
  )
}